import { render, staticRenderFns } from "./Scotland1.vue?vue&type=template&id=4aadda01"
import script from "./Scotland1.vue?vue&type=script&lang=js"
export * from "./Scotland1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports